import React, { useEffect, useState } from 'react';
import * as qs from 'query-string';
import { DynamicTableStateless } from '@atlaskit/dynamic-table';
import AddIcon from '@mui/icons-material/Add';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { PageHeaderList } from '../../../common/pageheaderlist/pageheaderlist';
import { ListWrapper } from '../../../common/layout/wrapper';
import { Breadcrumbs } from '../../../common/breadcrumbs/breadcrumbs';
import { FlagGroupError } from '../../../common/error/error';
import { ButtonCustom } from '../../../common/button/button';
import { Text } from '../../../common/text/Text';
import { createHeadTable, createRowsTable } from './listsaisines/tableutils';
import { CreateSaisine } from './listsaisines/createsaisine';
import { AutofillPreview } from './autofill/autofillpreview';

const SaisinesContainer = ({
  search,
  saisines = [],
  total = 0,
  loadingList,
  errors,
  eligibleClaims = [],
  eligibleLoading,
  autofill,
  autofillLoading,
  retrieveSaisines,
  createSaisine,
  searchEligibleClaims,
  clearEligibleClaims,
  runAutofillPreview,
  runAutofillApply,
  clearAutofill,
  dismissFlag,
}) => {
  const [showCreate, setShowCreate] = useState(false);

  useEffect(() => {
    const query = qs.parse(search);
    if ('paginateSize' in query) {
      retrieveSaisines(search);
    } else {
      retrieveSaisines('?paginateSize=50');
    }
  }, [search, retrieveSaisines]);

  const toggleCreate = () => {
    if (showCreate) clearEligibleClaims();
    setShowCreate(!showCreate);
  };

  return (
    <ListWrapper>
      <FlagGroupError data={errors} dismissFlag={dismissFlag} />
      <PageHeaderList
        breadcrumbs={(
          <Breadcrumbs
            fullName="Saisines groupées"
            key="SaisinesKey"
            location="#"
            text="Saisines"
          />
        )}
        actionsContent={(
          <>
            <ButtonCustom
              text="Remplissage automatique"
              onClick={runAutofillPreview}
              disabled={autofillLoading}
              startIcon={<AutoFixHighIcon />}
            />
            <ButtonCustom
              text={showCreate ? 'Fermer la création' : 'Créer une saisine'}
              onClick={toggleCreate}
              startIcon={<AddIcon />}
            />
          </>
        )}
      />
      {autofill ? (
        <AutofillPreview
          proposal={autofill}
          loading={autofillLoading}
          apply={runAutofillApply}
          cancel={clearAutofill}
        />
      ) : (
        <>
          {showCreate && (
            <CreateSaisine
              eligibleClaims={eligibleClaims}
              loading={eligibleLoading}
              search={searchEligibleClaims}
              create={createSaisine}
            />
          )}
          <Text color="secondary" variant="body2">{`${total} saisine(s)`}</Text>
          <DynamicTableStateless
            head={createHeadTable()}
            rows={createRowsTable(saisines)}
            loadingSpinnerSize="large"
            isLoading={loadingList}
            isFixedSize
            paginationi18n={{
              prev: 'Précédent',
              next: 'Suivant',
            }}
          />
        </>
      )}
    </ListWrapper>
  );
};

export {
  SaisinesContainer,
};
